import * as React from 'react'

import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box'
import { NavLink } from 'react-router-dom';
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import './Layout.scss'
import { ApiClient } from '../lib/ApiClient'
import { UrlHelpers } from '../lib/Helpers';
import { useResponsive } from '../lib/useResponsive';
import { useAuthenticated } from './auth/useAuthenticated'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { getUrl } from '../domain';
import { grey } from '@mui/material/colors';
import {
    Link
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import PhonelinkLockIcon from '@mui/icons-material/PhonelinkLock';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';

const apiClient = new ApiClient()

export const UcAppBar = () => {
    const { isMobile } = useResponsive();
    const fallbackUrl = getUrl("/account/logout");
    const [returnUrl] = React.useState<string>(UrlHelpers.getSafeUrl(new URLSearchParams(window.location.search).get('ReturnUrl') || fallbackUrl, fallbackUrl));
    const userAuth = useAuthenticated(apiClient);

    const theme = useTheme();

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleClickGoBackToClient = () => {
        window.location.href = decodeURIComponent(returnUrl);
    }

    return (
        <AppBar position="fixed" elevation={1} >
            <Toolbar sx={{ pl: 0 }}>
                {returnUrl !== fallbackUrl && (
                    <Box
                        sx={{
                            flexGrow: 0,
                            alignItems: 'center',
                            display: { xs: 'flex' },
                        }}
                        style={{ padding: '0 0 0 0' }}
                    >
                        <Button onClick={handleClickGoBackToClient} variant="outlined" sx={{ color: 'white', borderColor: 'white', paddingTop: 0, paddingBottom: 0, ml: 1 }}>
                            {isMobile ? (
                                <ChevronLeftIcon />
                            ) : (
                                <>
                                    <ChevronLeftIcon /> Back
                                </>
                            )}
                        </Button>
                    </Box>
                )}
                <Box sx={{ flexGrow: 1 }}>
                        <Link
                            href={getUrl("/account/home")}
                            variant="h6"
                            noWrap
                            id="utilismart-signin-services"
                            sx={{
                                mr: 2,
                                ml: 2,
                                fontWeight: 500,
                                color: 'inherit',
                                textDecoration: 'none',
                                fontSize: '1.25rem',
                                verticalAlign: 'text-top'
                            }}
                        >
                            Utilismart Sign-in Service
                        </Link>
                </Box>
                <Box sx={{ flexGrow: 0 }}>
                    <Tooltip title="">
                        <IconButton
                            sx={{ p: 0 }}
                            aria-controls={open ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleClick}
                        >
                            <Avatar alt={userAuth.result?.userName ?? ''} sx={{ bgcolor: grey[50], color: theme.palette.primary.main }}>
                            </Avatar>
                        </IconButton>
                    </Tooltip>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                        sx={{ mt: 1}}
                    >
                        <MenuItem onClick={handleClose} to={getUrl("/account/manage/profile")} component={NavLink}>
                            <ListItemIcon>
                                <SettingsIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Profile</ListItemText>
                        </MenuItem>
                        <MenuItem onClick={handleClose} to={getUrl("/account/manage/2fa")} component={NavLink}>
                            <ListItemIcon>
                                <PhonelinkLockIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Multi-factor Authentication</ListItemText>
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={handleClose} to={getUrl("/account/logout")} component={NavLink}>
                            <ListItemIcon>
                                <LogoutIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Logout</ListItemText>
                        </MenuItem>
                    </Menu>
                </Box>
            </Toolbar>
        </AppBar>
    )
}
